import Vue from 'vue';
import Deck from '@/classes/deck';

const state = {
  decks: { },
};

const getters = {
  get: (state) => state.decks,
  all: (state) => Object.keys(state.decks).map(d => state.decks[d]),
};

const mutations = {
  set: function(state, decks = []) {
    decks.map(d => new Deck(d)).forEach(deck => {
      Vue.set(state.decks, deck.id, deck);
    });
  },
};

const actions = {
  resetDeckStates({ commit, rootGetters }, deck) {
    return rootGetters['session/ajax'].post('/decks/reset', { id: deck.id }).then(() => {
      const attachmentCardAssetIds = deck.cards.filter(card => card.assetType === 'Attachment').map(card => card.assetId);
      commit('attachmentStates/delete', attachmentCardAssetIds, { root: true });

      const topicCardAssetIds = deck.cards.filter(card => card.assetType === 'Topic').map(card => card.assetId);
      commit('topicStates/delete', topicCardAssetIds, { root: true });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
